import { create } from 'zustand';

interface NavigationState {
  navigationSettings: {
    titleEnabled: boolean;
    title: string;
    navbarCustomColorsEnabled: boolean;
    navbarBgColor: string;
    navbarBgOpacity: number;
    navbarTextColor: string;
    navbarButtonPrimaryColor: string;
    navbarButtonSecondaryColor: string;
    navbarPathColor: string;
    sortingEnabled: boolean;
    defaultSorting: string;
    descriptionEnabled: boolean;
    filtersEnabled: boolean;
    webContentEnabled: boolean;
    webThumbnailEnabled: boolean;
    teleportButtonEnabled: boolean;
    autoMoveButtonEnabled: boolean;
    autoPlayEnabled: boolean;
    detailedRouteEnabled: boolean;
    videoTeaserEnabled: boolean;
  };
  navigationFinishScreen: {
    ratingEnabled: boolean;
    beforeVoteText: string;
    afterVoteText: string;
    sharingEnabled: boolean;
    popupTitle: string;
    qrEnabled: boolean;
    qrTitle: string;
    smsEnabled: boolean;
    smsTitle: string;
    smsText: string;
    policy: string;
  };
  sliderValue: number;
  navigationToast: boolean;
  navigationTranslation: { [key: string]: string };
  showChoicePopupSearchField: boolean;
}

interface NavigationActions {
  setNavigationSettings: (settings: any) => void;
  setNavigationFinishScreen: (screen: any) => void;
  setSliderValue: (value: number | ((prev: number) => number)) => void;
  setNavigationToast: (show: boolean) => void;
  setNavigationTranslation: (translation: { [key: string]: string }) => void;
  setShowChoicePopupSearchField: (show: boolean) => void;
}

export const useNavigationStore = create<NavigationState & NavigationActions>((set, get) => ({
  // State
  navigationSettings: {
    titleEnabled: false,
    title: '',
    navbarCustomColorsEnabled: false,
    navbarBgColor: '',
    navbarBgOpacity: 0.7,
    navbarTextColor: '',
    navbarButtonPrimaryColor: '',
    navbarButtonSecondaryColor: '',
    navbarPathColor: '#39b6fe',
    sortingEnabled: true,
    defaultSorting: 'default',
    descriptionEnabled: false,
    filtersEnabled: true,
    webContentEnabled: true,
    webThumbnailEnabled: true,
    teleportButtonEnabled: false,
    autoMoveButtonEnabled: true,
    autoPlayEnabled: true,
    detailedRouteEnabled: false,
    videoTeaserEnabled: true,
  },
  navigationFinishScreen: {
    ratingEnabled: true,
    beforeVoteText: '',
    afterVoteText: '',
    sharingEnabled: true,
    popupTitle: 'Get the route on your phone!',
    qrEnabled: true,
    qrTitle: 'Scan this QR code',
    smsEnabled: false,
    smsTitle: '',
    smsText: '',
    policy: '',
  },
  sliderValue: 0,
  navigationToast: false,
  navigationTranslation: {},
  showChoicePopupSearchField: false,

  // Actions
  setNavigationSettings: (settings) => set({ navigationSettings: settings }),
  setNavigationFinishScreen: (screen) => set({ navigationFinishScreen: screen }),
  setSliderValue: (value: number | ((prev: number) => number)) => {
    if (typeof value === 'function') {
      const currentValue = get().sliderValue;
      const newValue = value(currentValue);
      set({ sliderValue: newValue });
    } else {
      set({ sliderValue: value });
    }
  },
  setNavigationToast: (show) => set({ navigationToast: show }),
  setNavigationTranslation: (translation) => set({ navigationTranslation: translation }),
  setShowChoicePopupSearchField: (show) => set({ showChoicePopupSearchField: show }),
}));
